import Reveal from '@/components/base/Reveal';
import { useToast } from '@/components/feature/ToastProvider';
import { heroStats, heroTicker } from '@/mocks/homeData';

export default function Hero() {
  const { showToast } = useToast();

  return (
    <section id="top" className="relative flex min-h-[620px] flex-col justify-center overflow-hidden md:min-h-[760px]">
      <div className="absolute inset-0">
        <div className="h-full w-full">
          <img
            src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20background%20with%20deep%20warm%20crimson%20and%20amber%20gradient%20light%20streaks%2C%20subtle%20film%20grain%2C%20soft%20bokeh%20particles%2C%20low-key%20dramatic%20lighting%20for%20strong%20text%20contrast%2C%20cinematic%20atmosphere%20with%20generous%20dark%20negative%20space%2C%20no%20people%2C%20no%20readable%20text&width=1600&height=900&seq=hl-hero-01&orientation=landscape"
            alt="黑料在线 今日新瓜 热点区 主视觉背景"
            title="黑料在线 24小时更新 滚动爆料 吃瓜"
            className="h-full w-full object-cover object-top"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/60" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-shell px-4 pb-20 pt-32 md:px-6 md:pb-24 md:pt-40">
        <Reveal>
          <div className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 backdrop-blur">
            <span className="animate-live-dot h-1.5 w-1.5 rounded-full bg-accent-400" />
            <span className="text-xs tracking-wide text-background-100">社区讨论氛围 · 热点区 24 小时滚动更新</span>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <h2 className="mt-7 max-w-3xl font-heading text-3xl font-bold leading-[1.25] text-background-50 md:text-5xl md:leading-[1.2]">
            今日新瓜不断线，
            <br className="hidden sm:block" />
            一个页面看完整个事件的前因后果
          </h2>
        </Reveal>

        <Reveal delay={180}>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-background-100/85 md:text-base">
            热点区集中展示今日新瓜和最新消息，点开就能按时间线往下补。不用反复翻入口，边刷话题边补旧线，
            适合想看完整个最新动态的网友。
          </p>
        </Reveal>

        <Reveal delay={260}>
          <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#today"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base" />
              进入今日热点区
            </a>
            <a
              href="#timeline"
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-history-line text-base" />
              查看事件时间线
            </a>
            <button
              type="button"
              onClick={() => showToast('演示环境：订阅入口暂未开放')}
              className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-3 py-3.5 text-sm text-background-100/80 transition-colors hover:text-background-50"
            >
              <i className="ri-notification-3-line text-base" />
              每天更新提醒
            </button>
          </div>
        </Reveal>

        <Reveal delay={340}>
          <dl className="mt-14 grid w-full grid-cols-2 gap-y-6 border-t border-background-50/20 pt-8 md:grid-cols-4">
            {heroStats.map((stat) => (
              <div key={stat.label} className="md:border-l md:border-background-50/15 md:pl-6 md:first:border-l-0 md:first:pl-0">
                <dd className="flex items-baseline gap-1 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {stat.value}
                  <span className="text-xs font-normal text-accent-300">{stat.unit}</span>
                </dd>
                <dt className="mt-1.5 text-xs text-background-100/70 md:text-sm">{stat.label}</dt>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>

      <div className="relative z-10 flex items-center gap-4 border-t border-background-50/15 bg-black/25 py-3">
        <span className="ml-4 hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 md:flex md:ml-6">
          <i className="ri-flashlight-line" />
          滚动爆料
        </span>
        <div className="flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center">
            {[...heroTicker, ...heroTicker].map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center gap-3 whitespace-nowrap pr-10 text-xs text-background-100/80 md:text-sm"
              >
                <i className="ri-broadcast-line text-accent-400" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}